// removed by extract-text-webpack-plugin
module.exports = {"newsletter":"SubscriptionHeader__newsletter--p8o4P","bounce":"SubscriptionHeader__bounce--2Lfiz"};


//////////////////
// WEBPACK FOOTER
// ./src/subscriptions/components/SubscriptionHeader/SubscriptionHeader.css
// module id = ./src/subscriptions/components/SubscriptionHeader/SubscriptionHeader.css
// module chunks = 1